// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/create-sequence-number-request-schema',
  type: 'object',
  required: ['name', 'startNumber', 'increment'],
  properties: {
    name: {
      type: 'string',
      minLength: 1,
    },
    startNumber: {
      type: 'integer',
    },
    increment: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
